import AARTextField from "@/components/AARTextField";
import BaseDrawer from "@/components/BaseDrawer";
import CustomLabel from "@/components/CustomLabel";
import { RootState } from "@/store/store";
import { ComboBox, ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import { TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { useState } from "react";
import "react-image-crop/dist/ReactCrop.css";
import { useSelector } from "react-redux";

interface IProps {
  showCreateDrawer: boolean;
  setShowCreateDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  addNewLookup: any;
  handleChange: (e: TextBoxChangeEvent | ComboBoxChangeEvent) => void;
  onSave: () => void;
}

function WriteDrawer({
  showCreateDrawer,
  setShowCreateDrawer,
  addNewLookup,
  handleChange,
  onSave,
  ...drawerProps
}: IProps) {
  const { projects } = useSelector((state: RootState) => state.projects);

  const [invalidFields, setInvalidFields] = useState<{
    [key: string]: boolean;
  }>({});

  const validateSave = () => {
    return Object.values(invalidFields).every((field) => !field);
  };

  const renderDrawerContent = () => (
    <div className="grid gap-4">
      <div>
        <AARTextField
          name="code"
          value={addNewLookup?.code}
          onChange={handleChange}
          onValidate={(name, isValid) =>
            setInvalidFields((prev) => ({
              ...prev,
              [name]: !isValid,
            }))
          }
          label="Code"
          required={true}
          placeholder="Enter Code"
          disabled={false}
          error="Invalid Code"
        />
      </div>
      <div>
        <AARTextField
          name="value"
          value={addNewLookup?.value}
          onChange={handleChange}
          onValidate={(name, isValid) =>
            setInvalidFields((prev) => ({
              ...prev,
              [name]: !isValid,
            }))
          }
          label="Name"
          required={true}
          placeholder="Enter Name"
          disabled={false}
          error="Invalid Name"
        />
      </div>
    </div>
  );

  return (
    <>
      <BaseDrawer
        isOpen={showCreateDrawer}
        onClose={() => setShowCreateDrawer(false)}
        title={addNewLookup?.id ? "Edit" : "Add New"}
        primaryActionText={"Save"}
        onPrimaryAction={onSave}
        primaryActionDisabled={!validateSave()}
        {...drawerProps}
        maxW="35vw"
      >
        {renderDrawerContent()}
      </BaseDrawer>
    </>
  );
}

export default WriteDrawer;
